import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_2 = { class: "sm:flex sm:items-start" }
const _hoisted_3 = { class: "mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10" }
const _hoisted_4 = { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" }
const _hoisted_5 = {
  class: "text-lg leading-6 font-medium text-gray-900",
  id: "modal-headline"
}
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = { class: "text-sm leading-5 text-gray-500" }
const _hoisted_8 = { class: "bg-gray-100 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse rounded-b-lg" }
const _hoisted_9 = { class: "flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto" }
const _hoisted_10 = { class: "mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_WarningIcon = _resolveComponent("WarningIcon")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    show: _ctx.show,
    "set-close": _ctx.setClose,
    onClose: _cache[3] || (_cache[3] = $event => (_ctx.closeModal($event)))
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_WarningIcon, { class: "h-6 w-6 text-red-600" })
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("h3", _hoisted_5, _toDisplayString(_ctx.title), 1),
            _createVNode("div", _hoisted_6, [
              _createVNode("p", _hoisted_7, _toDisplayString(_ctx.text), 1)
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("span", _hoisted_9, [
          _createVNode("button", {
            type: "button",
            class: "inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5",
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.setCloseModal(true)))
          }, " Remove ")
        ]),
        _createVNode("span", _hoisted_10, [
          _createVNode("button", {
            type: "button",
            class: "inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5",
            onClick: _cache[2] || (_cache[2] = $event => (_ctx.setCloseModal(false)))
          }, " Cancel ")
        ])
      ])
    ]),
    _: 1
  }, 8, ["show", "set-close"]))
}